import React from "react";
import ReactDOM from "react-dom";
import NewsLetterOptionsForm from "./NewsLetterOptionsForm";

const NewsletterOptInOptOutPortal: React.FC = () => {
  const optInElement: HTMLDivElement | null = document.body.querySelector("#NewsletterOptIn > div");
  const optOutElement: HTMLDivElement | null = document.body.querySelector("#NewsletterOptOut > div");

  // OptOut (not implemented yet)
  if (optOutElement) {
    return ReactDOM.createPortal(<div>TODO: Opt out component</div>, optOutElement);
  }

  // OptIn
  if (optInElement) {
    return ReactDOM.createPortal(<NewsLetterOptionsForm />, optInElement);
  }

  // No output at all
  return null;
};

export default NewsletterOptInOptOutPortal;
